<template>
  <div class="date-page">
    <div class="page-top" v-if="allRoles.includes(userRole) || isWhiteUser || userState.haveCj || userState.haveClass">
      <div class="top-fixed"></div>
      <div class="flex-nav"
        v-if="ADMINROLES.includes(userRole) || EDITORROLES.includes(userRole) || isWhiteUser || (userState.haveCj && userState.haveClass)">
        <div class="nav-div bor-right" @click="handleClickJump('grade')">
          <img src="@/assets/images/cartojourney/img25.png" class="nav-icon" alt="">
          <div class="nav-con" v-if="userState && userState.haveClass">
            <div class="con-txt">我的班级</div>
          </div>
          <div class="nav-con" v-else>
            <div class="con-txt">班级管理</div>
            <div class="con-txt">
              <span class="txt-span">D</span>
              <img src="@/assets/images/cartojourney/img28.png" class="icon-span" alt="">
              <span class="txt-span">Pre-B+</span>
            </div>
          </div>
        </div>
        <div class="nav-div" @click="handleClickJump('cartoJourney')">
          <img src="@/assets/images/cartojourney/img26.png" class="nav-icon" alt="">
          <div class="nav-con" v-if="userState && userState.haveCj">
            <div class="con-txt">我的旅程</div>
          </div>
          <div class="nav-con" v-else>
            <div class="con-txt">旅程管理</div>
            <div class="con-txt">
              <span class="txt-span">Pre-B+</span>
              <img src="@/assets/images/cartojourney/img28.png" class="icon-span" alt="">
              <span class="txt-span">A</span>
            </div>
          </div>
        </div>
      </div>
      <div class="flex-nav center" @click="handleClickJump('grade-self')"
        v-else-if="DROLES.includes(userRole) || userState.haveClass">
        <div class="nav-div bor-right">
          <img src="@/assets/images/cartojourney/img25.png" class="nav-icon" alt="">
          <div class="nav-con">
            <div class="con-txt">我的班级</div>
          </div>
        </div>
      </div>
      <div class="flex-nav center" @click="handleClickJump('carto-self')"
        v-else-if="PREROLES.includes(userRole) || userState.haveCj">
        <div class="nav-div bor-right">
          <img src="@/assets/images/cartojourney/img26.png" class="nav-icon" alt="">
          <div class="nav-con">
            <div class="con-txt">我的旅程</div>
          </div>
        </div>
      </div>
    </div>
    <dateVue></dateVue>
    <barComponentsVue></barComponentsVue>
    <custom-dialog
      :visible.sync="cDialog.visible"
      v-bind="cDialog"
      @cancel="cDialog.cancel"
      @confirm="cDialog.cancel">
      <div class="txts" v-if="DROLES.includes(userRole)">{{ cDialog && cDialog.content1 }}</div>
      <div class="txts" v-else>{{ cDialog && cDialog.content2 }}</div>
    </custom-dialog>
    <custom-dialog
      :visible.sync="cDialog1.visible"
      v-bind="cDialog1"
      @cancel="cDialog1.cancel"
      @confirm="cDialog1.confirm">
      <div class="txts">{{ cDialog1 && cDialog1.content }}</div>
    </custom-dialog>
  </div>
</template>
<script>
import dateVue from './components/date.vue'
import { getUsersRole, checkCJ, handleGetDateStatus } from '@/api/cartoJourney.js'
import { joinClassRoom, classUserPermissions, whiteUser } from '@/api/grade'
import { userClass } from '@/api/grade.js'
import barComponentsVue from '../../components/barComponents.vue'
import CustomDialog from './components/CustomDialog.vue'
import withRouteTracking from '@/utils/withRouteTracking'
// import { PEROLES, CDROLES, DROLES, PREROLES } from '@/utils/configRoles.js'
import { DROLES, PREROLES } from '@/utils/configRoles.js'
import {dictionaryList} from '@/api/api'

const UserProfile = {
  data () {
    return {
      cDialog: {
        visible: false,
        showCancelButton: false,
        closeIcon: false,
        confirmButtonText: '知道了',
        content1: '您还未加入特定班级，请等待管理员为您进行班级配置',
        content2: '您还未加入特定旅程，请等待管理员为您进行旅程配置',
        confirm: () => {
          this.cDialog.close()
        },
        cancel: () => {
          this.cDialog.close()
        },
        close: () => {
          this.cDialog.visible = false
        }
      },
      cDialog1: {
        visible: false,
        closeIcon: false,
        confirmButtonText: '加入',
        cancelButtonText: '回首页',
        cancel: () => {
          this.handleGradeCancel()
        },
        confirm: () => {
          this.handleConfirm()
        },
        close: () => {
          this.cDialog1.visible = false
        },
      },
      userRole: '',
      className: '',
      premissObj: {},
      // PEROLES,
      // CDROLES,
      DROLES,
      PREROLES,
      // allRoles: [...ADMINROLES, ...CDROLES, ...DROLES, ...PREROLES],
      isWhiteUser: false,
      userState: {},
      gradeRolesList: {}
    }
  },
  components: {
    dateVue,
    barComponentsVue,
    CustomDialog
  },
  computed: {
    userInfo () {
      return this.$store.getters.userInfo
    },
    ADMINROLES() {
      return this.gradeRolesList.ADMINROLES || []
    },
    EDITORROLES() {
      return this.gradeRolesList.EDITORROLES || []
    },
    allRoles() {
      return [...this.ADMINROLES, ...this.EDITORROLES, ...DROLES, ...PREROLES]
    }
  },
  async mounted () {
    if (sessionStorage.getItem('gradeRolesList')) {
      this.gradeRolesList = JSON.parse(sessionStorage.getItem('gradeRolesList'))
    } else {
      let params = {
        typeCodeList: ['CLASS_OPEN_EDITOR', 'CLASS_SELECT_ADMIN'],
        dataStatus: '1'
      }
      const {code, data} = await dictionaryList(params)
      if (code === 0) {
        let dataObj = {
          EDITORROLES: data.filter(item => item.typeCode === 'CLASS_OPEN_EDITOR').map(item => item.code),
          ADMINROLES: data.filter(item => item.typeCode === 'CLASS_SELECT_ADMIN').map(item => item.code),
        }
        sessionStorage.setItem('gradeRolesList', JSON.stringify(dataObj))
        this.gradeRolesList = JSON.parse(sessionStorage.getItem('gradeRolesList'))
      }
    }
    // this.userInfo.email
    whiteUser({ email: this.userInfo.email }).then(resUser => {
      this.isWhiteUser = resUser.data
      sessionStorage.setItem('isWhiteUser', JSON.stringify(this.isWhiteUser ? resUser.data : false))
    }).catch(err => console.log(err))
    this.initHandle()
    sessionStorage.removeItem('selectGradeCurrentJourney')
  },
  methods: {
    initHandle () {
      // 有我的班级的术者：D/C
      // 有我的旅程的术者：Pre B+/B+/Pre A/A
      // 班级管理的员工：PE/DPEM（创建）CS/CD（只看）
      // 旅程管理的员工：PE/DPEM（创建）CS/CD（只看）
      if (this.userInfo.memberType === 1) {
        getUsersRole({ userId: this.userInfo.id }).then(res => {
          this.userRole = res.data
          sessionStorage.setItem('userRole', this.userRole)
          // if (DROLES.includes(this.userRole)) {
          //   userClass({userId: this.userInfo.id}).then(res => {
          //     this.classId = res.data
          //     this.classId && this.getClassUserPermissions()
          //   })
          // }
          // if (this.userRole === 'Pre B+' || this.userRole === 'B+' || this.userRole === 'Pre A' || this.userRole === 'A') {
          //   checkCJ({multiCode: this.userInfo.multiCode}).then(res => {
          //     this.checkCJBool = (res.code === 0)
          //   })
          // }
        })
      } else {
        handleGetDateStatus({ userId: this.userInfo.id }).then(res => {
          this.userState = res.data
          if (res.data.haveCj) {
            checkCJ({ multiCode: this.userInfo.multiCode }).then(res => {
              this.checkCJBool = (res.code === 0)
            })
          }
          if (res.data.haveClass && res.data.classId) {
            userClass({ userId: this.userInfo.id }).then(res => {
              this.classId = res.data
              this.classId && this.getClassUserPermissions()
            })
          }
        })
      }
    },
    // 获取用户班级角色权限
    getClassUserPermissions () {
      const params = {
        classId: this.classId,
        userId: this.userInfo.id
      }
      classUserPermissions(params).then(res => {
        const data = res.data
        this.className = data.className
        this.cDialog1.content = `您已被邀请到 ${this.className} 班级，但还没加入是否需要加入！`
        this.premissObj = data
      })
    },
    handleGradePage () {
      this.$router.push({
        path: '/gradeHomePage',
        query: {
          classId: this.classId
        }
      })
    },
    handleGradeCancel () {
      this.cDialog1.visible = false
      this.$router.push({
        path: '/home',
      })
    },
    handleConfirm () {
      const params = {
        classId: this.classId,
        userId: this.userInfo.id
      }
      joinClassRoom(params).then(res => {
        if (res.code === 0) {
          sessionStorage.setItem('changeGradeTabActive', 1)
          this.handleGradePage()
          this.$toast('您已加入班级')
        }
      })
    },
    handleClickJump (type) {
      if (!this.classId && (DROLES.includes(this.userRole))) {
        this.cDialog.visible = true
        return
      }
      if (!this.checkCJBool && (this.userRole === 'Pre B+' || this.userRole === 'B+' || this.userRole === 'Pre A' || this.userRole === 'A')) {
        this.cDialog.visible = true
        return
      }
      let path = ''
      let query = {}
      if (type === 'grade') {
        if (this.userState.haveClass) {
          sessionStorage.setItem('changeGradeTabActive', 1)
          path = `/gradeHomePage`
          query.classId = this.classId
        } else {
          path = `/grade`
        }
      } else if (type === 'grade-self') {
        if (this.premissObj.inClassList && this.premissObj.userStatus === 1) {
          sessionStorage.setItem('changeGradeTabActive', 1)
          path = `/gradeHomePage`
          query.classId = this.classId
        } else {
          this.cDialog1.visible = true
        }
      } else if (type === 'cartoJourney') {
        if (this.userState.haveCj) {
          path = '/journeyPage'
          query.isSurgeon = true
          query.customizedMultiCode = this.userInfo.multiCode
        } else {
          path = '/surgeonList'
        }
      } else if (type === 'carto-self') {
        path = '/journeyPage'
        query.isSurgeon = true
        query.customizedMultiCode = this.userInfo.multiCode
      }
      this.$router.push({
        path,
        query
      })
    }
  },
}
export default withRouteTracking(UserProfile)
</script>
<style lang="less" scoped>
.date-page {
  padding-bottom: 60px;
  background: #F9F8F7;
  box-sizing: border-box;

  .top-fixed {
    position: absolute;
    top: 0;
    left: 0;
    background: linear-gradient(180deg, #EB1700 0%, rgba(235, 23, 0, 0) 100%);
    width: 100%;
    height: 258px;
  }

  .page-top {
    padding: 16px 10px;
    box-sizing: border-box;
  }

  .flex-nav {
    position: relative;
    display: flex;
    background-color: #fff;
    border-radius: 8px;

    &.center {
      justify-content: center;

      .bor-right {
        &::after {
          display: none;
        }
      }
    }

    .nav-div {
      display: flex;
      align-items: center;
      padding: 16px;
      box-sizing: border-box;
      width: 50%;

      &.bor-right {
        position: relative;

        &::after {
          position: absolute;
          right: 0;
          border-right: 1px solid #E5E5E5;
          height: 32px;
          top: 50%;
          transform: translateY(-50%);
          content: '';
        }
      }

      .nav-icon {
        width: 38px;
        display: block;
        margin-right: 7px;
      }

      .nav-con {
        .con-txt {
          font-family: PingFang HK, PingFang HK;
          font-weight: 500;
          font-size: 16px;
          color: #000000;
          line-height: 20px;
          display: flex;
          align-items: center;

          .txt-span {
            font-weight: bold;
            font-family: Alimama ShuHeiTi, Alimama ShuHeiTi;
            font-size: 14px;
            color: #EB1700;
          }
        }

        .icon-span {
          display: block;
          width: 10px;
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/views/cartoJourney/date.vue